import api from "./api.ts";

export async function saveAnswer(answers: any[]) {
  const token = localStorage.getItem("token");
  return api.post(
    "/answer",
    answers,
    { headers: token ? { Authorization: `Bearer ${token}` } : {} }
  );
}
